<ng-container *ngIf="loading">
  <div class="financing">
    <div class="financing_info">
      <table *ngIf="valuesLoading">
        <thead>
          <tr>
            <th></th>
            <th colspan="3">Общая освоенная сумма</th>
            <th colspan="2">Сумма освоения за счёт средств <br> АО "Казахстанская жилищная компания"</th>
            <th colspan="2">Сумма освоения за счёт собственных</th>
          </tr>
          <tr>
            <th></th>

            <th>План</th>
            <th>Факт</th>
            <th>Остаток</th>

            <th class="bold">План</th>
            <th class="bold">Факт</th>

            <th class="bold">План</th>
            <th class="bold">Факт</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ВСЕГО</td>

            <td>
              {{calculate(ppInv, bdInv) | numberWithSpaces}}
            </td>
            <td>{{total_second + total_first  | numberWithSpaces}}</td>
            <td>
              {{ calculate(ppInv, bdInv) - (total_second + total_first) | numberWithSpaces}}
            </td>

            <td class="bold">
              {{ bdInv | numberWithSpaces}}
            </td>
            <td class="bold">{{total_second | numberWithSpaces}}</td>

            <td>{{ppInv | numberWithSpaces}}
            </td>
            <td>{{total_first | numberWithSpaces}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="financing_details">
      <div class="radio-group">

        <input type="radio" id="option-two" name="selector" (click)="openCalendarModule('bd', false)">
        <label for="option-two">
          <div class="bd-option">
            <div>Освоение средств</div>БД
          </div>
        </label>

        <input type="radio" id="option-one" name="selector" checked="checked"
          (click)="openCalendarModule('own', false)">

        <label for="option-one">
          <div class="bd-option">Освоение собственных <br> средств</div>
        </label>

        <div class="financing-completed">
          <div class="btn btn-change" (click)="noChanges()">
            Изменений не было
          </div>
        </div>
      </div>
      <!--
      <span class="finance-date">{{(investor_type === 'bd' ? bdDate : ownDate) | date: 'dd MMM yyyy': '' : 'ru-KZ' }}</span>
      <div class="btn btn-light" (click)="openCalendarModule(investor_type, false)" [ngClass]="!firstFinanceBtn?'':'noneActive'">
        {{(investor_type === 'bd' ? total_fact_btn_second : total_fact_btn_first) | numberWithSpaces}}
      </div>

      <div class="btn btn-confirm" (click)="updateTable()">Подтвердить</div>
      <div class="btn btn-danger" (click)="clearData()">Очистить</div> -->
      <div class="financing-completed">
        <div class="btn" (click)="!firstFinanceBtn?stopFinancing():''"
          [ngClass]="!firstFinanceBtn?'btn-confirm':'btn-cancel noneActive'">
          Финансирование завершено
        </div>
      </div>
      <div class="btn btn-confirm btn-circle" (click)="financeGraphicModal = true">
        <span class="icon-chart"></span>
      </div>
    </div>
    <div class="financing_table">
      <table>
        <thead>
          <tr>
            <th>№</th>
            <th class="order-by-desc" (click)="orderBy('summary')">Сумма</th>
            <th>Назначение</th>
            <th class="order-by-desc" (click)="orderBy('date')">Дата</th>
            <th class="order-by-desc" (click)="orderBy('investor')">Освоение</th>
            <th *ngIf="userRole === rolesEnum.BDAdmin"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of investmentsTable; let i=index">
            <td>{{i+1}}</td>
            <td style="padding:0;">

              <div class="item-amount">{{item.amount1? item.amount1: ''}} <ng-container
                  *ngIf="item.amount1 && item.amount2">
                  <hr>
                </ng-container>
              </div>
              <div class="item-amount">{{item.amount2? item.amount2: ''}} <ng-container
                  *ngIf="item.amount2 && item.amount3">
                  <hr>
                </ng-container>
              </div>
              <div class="item-amount">{{item.amount3? item.amount3: ''}} <ng-container
                  *ngIf="item.amount3 && item.amount4">
                  <hr>
                </ng-container>
              </div>
              <div class="item-amount">{{item.amount4? item.amount4: ''}}</div>



            </td>
            <td style="padding:0;">
              <div class="item-amount">{{item.amount1? 'СМР': ''}} <ng-container *ngIf="item.amount1 && item.amount2">
                  <hr>
                </ng-container>
              </div>
              <div class="item-amount">{{item.amount2? 'Технический надзор': ''}} <ng-container
                  *ngIf="item.amount2 && item.amount3">
                  <hr>
                </ng-container>
              </div>
              <div class="item-amount">{{item.amount3? 'Авторский надзор': ''}} <ng-container
                  *ngIf="item.amount3 && item.amount4">
                  <hr>
                </ng-container>
              </div>
              <div class="item-amount">{{item.amount4? 'Дополнительные расходы': ''}}</div>
            </td>
            <td class="text-uppercase">{{item.factDate | date: 'dd MMM yyyy': '' : 'ru-KZ' }}</td>
            <td>{{item.mioTitle}}</td>
            <td *ngIf="userRole === rolesEnum.BDAdmin">
              <div class="btn " [ngClass]="!firstFinanceBtn?'btn-dark':'btn-cancel noneActive'" (click)="!firstFinanceBtn?editInvestment(item):''">Редактировать</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!loading">
  <div class="loading"></div>
</ng-container>

<ng-container *ngIf="calendarModalOwnAmount">
  <app-modal-window [title]="'График инвестирования'" [visible]="calendarModalOwnAmount"
    (close)="calendarModalOwnAmount = $event" [width]="1300" [scrollbar]="false">
    <app-calendar [acceptBtnFlag]="false" [inputStartDate]="object?.development_start_date"
      [financingEndDate]="object?.development_end_date" [duration]="object.duration" [use]="'financing'"
      [livingComID]="livingComplexId" [obj]="obj" [calendarType]="'setValueInDate'" [openedCalendar]="openedCalendar"
      [inputCompleteDate]="completeDatesOwnAmount" [editedDate]="editedDate" [valueDimension]="''"
      [financingObject]="financingObject"
      (outputCompleteDate)="completeDatesFunct(completeDatesOwnAmount=$event, 'own'); calendarModalOwnAmount = false">
    </app-calendar>
  </app-modal-window>
</ng-container>


<ng-container *ngIf="calendarModalBdDevelopment">
  <app-modal-window [title]="'График инвестирования'" [visible]="calendarModalBdDevelopment"
    (close)="calendarModalBdDevelopment = $event" [width]="1300" [scrollbar]="false">
    <app-calendar [acceptBtnFlag]="false" [inputStartDate]="object?.development_start_date"
      [financingEndDate]="object?.development_end_date" [duration]="object.duration" [use]="'financing'"
      [livingComID]="livingComplexId" [obj]="obj" [calendarType]="'setValueInDate'"
      [inputCompleteDate]="completeDatesBdDevelopment" [editedDate]="editedDate" [openedCalendar]="openedCalendar"
      [valueDimension]="''" [financingObject]="financingObject"
      (outputCompleteDate)="completeDatesFunct(completeDatesBdDevelopment=$event, 'bd'); calendarModalBdDevelopment = false">
    </app-calendar>
  </app-modal-window>
</ng-container>
<app-modal-window *ngIf="financeGraphicModal" [title]="'Динамика по поступлению средств на объект'"
  [visible]="financeGraphicModal" [height]="600" [width]="1000" (close)="financeGraphicModal = $event">
  <app-widget-finance-graphic [object]="object"></app-widget-finance-graphic>
</app-modal-window>

<app-modal-window [title]="'Завершение финансирования'" [visible]="openConfirmDialog"
  (close)="openConfirmDialog = $event" [width]="550" [height]="380">
  <div class="confirm">
    <div class="body">
      <div class="warning">
        <img src="assets/svg-icons/warning.svg" alt="">
      </div>
      <div class="text main"> Вы уверены, что хотите завершить финансирование?</div>
      <div class="text secondary">
        В случае выбора "ДА", дальнейший ввод данных будет заблокирован!
      </div>
    </div>
    <!-- <div style="padding: 10px;">
      Для завершения финансирования прикрепите документ "Акт ввода при завершении строительства".
    </div> -->
    <!-- <div class="fileLoading">
      <input type="file" (change)="uploadFile($event.target.files)" />
    </div> -->
    <div class="btns">
      <!-- <div class="btn btn-apply" (click)="!mioReadOnlyUserFlag ? (access[closedFlag == 'first' ? 0 : 1] ? confirmFinance() : '') : ''"
        [ngClass]="access[closedFlag == 'first' ? 0 : 1] ? '' : 'btn-cancel'">ДА</div> -->
        <div class="btn btn-apply" (click)="confirmFinance()"
        [ngClass]="access[(closedFlag == 'first') ? 0 : 1] ? '' : 'btn-cancel'">ДА</div>
      <div class="btn btn-cancel" (click)="cancelFinance()">НЕТ</div>
    </div>
  </div>
</app-modal-window>


<app-modal-window [title]="'Завершение финансирования'" [visible]="changes" (close)="changes = $event" [width]="550"
  [height]="380">
  <div class="confirm">
    <div class="body">
      <div class="warning">
        <img src="assets/svg-icons/warning.svg" alt="">
      </div>
      <div class="text main"> Вы подтверждаете, что изменений за текущую неделю не было?</div>
      <!-- <div class="text secondary">
        {{lastNoChanges}}
      </div> -->
    </div>
    <div class="btns">
      <div class="btn btn-apply" (click)="acceptNoChanges()">ДА</div>
      <div class="btn btn-cancel" (click)="cancelFinance()">НЕТ</div>
    </div>
  </div>
</app-modal-window>
